export enum ConcessionSlug {
  FRANCE = 'france',
  PORTUGAL = 'portugal',
  ITALY = 'italia',
  SPAIN = 'espana',
  DEUTSCHLAND = 'deutschland',
  UNITED_KINGDOM = 'united-kingdom',
  FLORIDA = 'florida',
  MEXICO = 'mexico'
}
